import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePairAssignmentsInputClass;
function SavePairAssignmentsInput() {
  if (SavePairAssignmentsInputClass === VOID) {
    class $ {
      constructor(partyId, pairingSetId, date, pairs, discordMessageId, slackMessageId) {
        discordMessageId = discordMessageId === VOID ? Absent_getInstance() : discordMessageId;
        slackMessageId = slackMessageId === VOID ? Absent_getInstance() : slackMessageId;
        this.p6p_1 = partyId;
        this.q6p_1 = pairingSetId;
        this.r6p_1 = date;
        this.s6p_1 = pairs;
        this.t6p_1 = discordMessageId;
        this.u6p_1 = slackMessageId;
      }
      toString() {
        return 'SavePairAssignmentsInput(partyId=' + this.p6p_1.toString() + ', pairingSetId=' + this.q6p_1.toString() + ', date=' + this.r6p_1.toString() + ', pairs=' + toString(this.s6p_1) + ', discordMessageId=' + toString(this.t6p_1) + ', slackMessageId=' + toString(this.u6p_1) + ')';
      }
      hashCode() {
        var result = this.p6p_1.hashCode();
        result = imul(result, 31) + this.q6p_1.hashCode() | 0;
        result = imul(result, 31) + this.r6p_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.s6p_1) | 0;
        result = imul(result, 31) + hashCode(this.t6p_1) | 0;
        result = imul(result, 31) + hashCode(this.u6p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePairAssignmentsInput()))
          return false;
        if (!this.p6p_1.equals(other.p6p_1))
          return false;
        if (!this.q6p_1.equals(other.q6p_1))
          return false;
        if (!this.r6p_1.equals(other.r6p_1))
          return false;
        if (!equals(this.s6p_1, other.s6p_1))
          return false;
        if (!equals(this.t6p_1, other.t6p_1))
          return false;
        if (!equals(this.u6p_1, other.u6p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePairAssignmentsInput');
    SavePairAssignmentsInputClass = $;
  }
  return SavePairAssignmentsInputClass;
}
//region block: exports
export {
  SavePairAssignmentsInput as SavePairAssignmentsInput3tgrc8c2zd524,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsInput.mjs.map
